<div>
  <p>Select template Dialog</p>
</div>